import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'commaToDot',
    standalone: true,
})
export class CommaToDotPipe implements PipeTransform {
    public transform(value: string | number): string | number {
        if (typeof value !== 'string') {
            return value;
        }
        return value.replace(',', '.');
    }
}
